import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { GUARANTEED_RENT_CITIES } from "./cityConfig";

export default function GuaranteedRentLocations() {
  return (
    <section style={{ backgroundColor: "#F4F1E7", padding: "clamp(60px,7vw,96px) clamp(20px,5vw,80px)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C7268", marginBottom: 12, marginTop: 0 }}>
            Our Locations
          </p>
          <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(28px, 4vw, 44px)", letterSpacing: "-0.02em", lineHeight: 1.15, color: "#112215", margin: "0 auto 14px", maxWidth: 640 }}>
            Guaranteed rent across the UK
          </h2>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 16, color: "#5C7268", lineHeight: 1.6, maxWidth: 540, margin: "0 auto" }}>
            We offer guaranteed rent in cities nationwide. Choose your location to see local income estimates and request a free valuation.
          </p>
        </div>

        <div className="gr-locs-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16 }}>
          {GUARANTEED_RENT_CITIES.map((c) => (
            <Link
              key={c.slug}
              to={`/guaranteed-rent/${c.slug}/`}
              style={{
                position: "relative",
                display: "block",
                borderRadius: 14,
                overflow: "hidden",
                textDecoration: "none",
                aspectRatio: "4 / 3",
                transition: "transform 0.2s, box-shadow 0.2s",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 12px 32px rgba(0,0,0,0.16)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
            >
              <img src={c.heroImage} alt={`${c.name} - Truestays guaranteed rent ${c.name}`} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} loading="lazy" decoding="async" />
              <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.1) 55%, transparent 100%)" }} />
              <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: "16px 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 16, color: "#fff", margin: 0, letterSpacing: "-0.01em" }}>{c.name}</span>
                <ArrowRight size={16} color="#fff" />
              </div>
            </Link>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) { .gr-locs-grid { grid-template-columns: repeat(3, 1fr) !important; } }
        @media (max-width: 640px) { .gr-locs-grid { grid-template-columns: repeat(2, 1fr) !important; } }
        @media (max-width: 420px) { .gr-locs-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}